import { createFileRoute } from "@tanstack/react-router";
import { ConditionPageLayoutEs } from "@/components/ConditionPageLayoutEs";
import { esOcd } from "@/pages/es/esConditionData2";
import { buildEsConditionHead } from "@/pages/es/esConditionShared";

export const Route = createFileRoute("/es/ocd-treatment-coral-springs-fl")({
  head: () => buildEsConditionHead(esOcd),
  component: RouteComponent,
});

function RouteComponent() {
  return <ConditionPageLayoutEs cfg={esOcd} />;
}
